import './styles.css'
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useNavigate } from 'react-router-dom';
import { login } from '../../firebaseFunctions/authhook';
import { ClipLoader } from 'react-spinners';


const Login: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="homeDesign flex_design_login">
            <div className="login-col">
                <p className="loginText">ادخل كلمة المرور</p>
                <Formik
                    initialValues={{
                        password: "",
                    }}
                    validationSchema={Yup.object().shape({
                        password: Yup.string()
                            .min(4, 'First name is too short')
                            .max(15, 'First name Too Long!')
                            .required("First Name is required")
                    })}
                    onSubmit={async ({ password }, { setStatus, setSubmitting }) => {
                        setSubmitting(true);
                        await login('ifahad@gmail.com', password)
                            .then((userCredential) => {
                                const user = userCredential.user;
                                const email = user.email;
                                localStorage.setItem('email', `${email}`)
                                navigate('/cp')
                            })
                            .catch((error) => {
                                const errorMessage = error.message;
                                setStatus(errorMessage)
                            });
                        setSubmitting(false);
                    }}
                >
                    {({ errors, status, touched, isSubmitting }) => (
                        <Form>
                            <div className="labelDesign">
                                <label>
                                    <Field
                                        className="inputDesign"
                                        name="password"
                                        type="text"
                                        placeholder="كلمة المرور"
                                    />
                                    {errors.password && touched.password ? (
                                        <div>
                                            <small style={{ color: "red" }}>{errors.password}</small>
                                        </div>
                                    ) : null}
                                    {
                                        status && <small>{status}</small>
                                    }
                                </label>
                            </div>
                            <div className="flex_design login_btn">
                                <button
                                    type="submit"
                                    className="cta homeBottomText"
                                >
                                    {
                                        isSubmitting ?
                                            <ClipLoader color={'#ffffff'} loading={true} size={40} />
                                            :
                                            'دخول'
                                    }
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    )
}

export default Login;
